import _ from 'lodash';
export function encodeHtml(input: string): string {
	return _.escape(input);
}
